<template>
  <div class="input-text input-text--filter input-text-filter">
    <input
      v-model="searchCriterion"
      type="text"
      :placeholder="placeholder"
      @change="onChange"
      @input="onInput"
    >
    <span
      v-if="searchCriterion !== ''"
      class="input-text-filter__empty"
      @click="emptySearch"
    />
  </div>
</template>

<script>
export default {
  name: 'InputSearch',
  props: {
    placeholder: { type: String, default: '' },
    value: { type: String, default: '' },
  },
  data() {
    return {
      searchCriterion: this.$props.value,
    };
  },
  methods: {
    emptySearch() {
      this.searchCriterion = '';
      this.$emit('change', '');
      this.$emit('search-input', '');
    },
    onChange() {
      this.$emit('change', this.searchCriterion);
    },
    onInput() {
      this.$emit('search-input', this.searchCriterion);
    },
  },
};
</script>
